import { createContext, useContext } from "react"

import { strings, type BuilderStrings } from "@/strings"

const StringsContext = createContext<BuilderStrings>(strings)

export const StringsProvider = StringsContext.Provider
export const useStrings = () => useContext(StringsContext)

export type { BuilderStrings }
